import React from 'react';
import { Link } from 'react-router-dom';
import { Button, ButtonGroup, Container } from "reactstrap";

const Main = () => (
  <Container>
    <div className="rounded px-3 px-sm-4 py-3 py-sm-5">
      <h1 className="display-3">Welcome!</h1>
      <p className="lead">This is a user management page for Testbank.</p>
      <hr/>
      <div className="lead">
        <ButtonGroup>
          <Button tag={Link} to="/users">List all users</Button>
          <Button color="primary" tag={Link} to="/new">Add new user</Button>
        </ButtonGroup>
      </div>
    </div>
  </Container>
)

export default Main;
